import React, { useContext, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Typography,
  Button,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  useMediaQuery,
  useTheme,
  Divider,
} from "@mui/material";
import { Settings, Menu as MenuIcon, Logout, AccountCircle } from "@mui/icons-material";
import { useMsal } from "@azure/msal-react";
import { GlobalContext } from "../context/GlobalContext";
import LogoCaldenFlow from "../utils/images/logo_audit.png";
import LogoAoniken from "../utils/images/logo_aoniken.png";

const Nav = () => {
  const { context, setContext } = useContext(GlobalContext);
  const { instance, accounts } = useMsal();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [selected, setSelected] = useState("Consulta");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const currentUser = accounts[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = (event) => {
    setAnchorElProfile(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorElProfile(null);
  };

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleMenuItemClick = (val) => {
    setSelected(val);

    switch (val) {
      case "Observados":
        setContext({ ...context, page: "listObs" });
        break;
      case "Consulta":
        setContext({ ...context, page: "listPrint" });
        break;
      case "Temporizador":
        setContext({ ...context, page: "timerConfig" });
        break;
      case "Notas de Venta":
        setContext({ ...context, page: "notasVenta" });
        break;
      default:
        setContext({ ...context, page: "listPrint" });
        break;
    }

    setDrawerOpen(false);
    handleClose();
  };

  const handleDropdownChange = (val) => {
    handleMenuItemClick(val);
  };

  const menuItems = [
    { label: "Observados", value: "Observados" },
    { label: "Consulta", value: "Consulta" },
    { label: "Temporizador", value: "Temporizador" },
    { label: "Notas de Venta", value: "Notas de Venta" }
  ];

  return (
    <Box
      sx={{
        flexGrow: 1,
        marginBottom: 3,
        "@media print": {
          display: "none",
        },
      }}
    >
      <AppBar position="static">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img src={LogoCaldenFlow} alt="Logo CaldenFlow" width="130px" />
            <img src={LogoAoniken} alt="Logo Aoniken" height="33px" />
          </Box>

          {(context.page == "listObs" ||
            context.page == "listPrint" ||
            context.page === "timerConfig" ||
            context.page === "notasVenta") && (
            <>
              {isMobile ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerToggle}
                    sx={{ ml: 1 }}
                  >
                    <MenuIcon />
                  </IconButton>
                </Box>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <div>
                    <Button
                      variant="text"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                      sx={{ color: "white" }}
                    >
                      {selected}
                    </Button>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {menuItems.map((item) => (
                        <MenuItem
                          key={item.value}
                          onClick={() => handleDropdownChange(item.value)}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                  
                  {currentUser && (
                    <div>
                      <Button
                        variant="text"
                        aria-controls="profile-menu"
                        aria-haspopup="true"
                        onClick={handleProfileClick}
                        sx={{ color: "white", display: "flex", alignItems: "center", gap: 1 }}
                        startIcon={<AccountCircle />}
                      >
                        {currentUser.name || currentUser.username}
                      </Button>
                      <Menu
                        id="profile-menu"
                        anchorEl={anchorElProfile}
                        keepMounted
                        open={Boolean(anchorElProfile)}
                        onClose={handleProfileClose}
                      >
                        <MenuItem disabled>
                          <Box>
                            <Typography variant="body2" fontWeight="bold">
                              {currentUser.name || "Usuario"}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {currentUser.username}
                            </Typography>
                          </Box>
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                          <ListItemIcon>
                            <Logout fontSize="small" />
                          </ListItemIcon>
                          Cerrar Sesión
                        </MenuItem>
                      </Menu>
                    </div>
                  )}
                </Box>
              )}
              
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleDrawerToggle}
                sx={{
                  '& .MuiDrawer-paper': {
                    width: 250,
                    boxSizing: 'border-box',
                  },
                }}
              >
                <Box
                  sx={{ width: 250 }}
                  role="presentation"
                >
                  <List>
                    {menuItems.map((item) => (
                      <ListItem key={item.value} disablePadding>
                        <ListItemButton
                          onClick={() => handleMenuItemClick(item.value)}
                          selected={selected === item.value}
                        >
                          <ListItemText primary={item.label} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                  
                  {currentUser && (
                    <>
                      <Divider />
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <AccountCircle />
                          </ListItemIcon>
                          <ListItemText 
                            primary={currentUser.name || "Usuario"}
                            secondary={currentUser.username}
                          />
                        </ListItem>
                        <ListItem disablePadding>
                          <ListItemButton onClick={handleLogout}>
                            <ListItemIcon>
                              <Logout />
                            </ListItemIcon>
                            <ListItemText primary="Cerrar Sesión" />
                          </ListItemButton>
                        </ListItem>
                      </List>
                    </>
                  )}
                </Box>
              </Drawer>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Nav;
